(ns app.front.date-impl
  (:require [app.date-common :as date]
            [core.front.date-util :as date-util]))

;; Note that this also covers goog.date.DateTime due to inheritance
(extend-type goog.date.Date

  date/ComparableDate
  (-before?
    [this another]
    (date-util/before? this another))

  date/AdjustableDate
  (-add-days
    [this days]
    (-> (.clone this)
        (date-util/goog-add-days days)))
  (-subtract-days
    [this days]
    (-> (.clone this)
        (date-util/goog-add-days (- days)))))
